import { SelectChip } from "~/common/mui/Chip/SelectChip";
import type { FilterOptionDTO } from "~/features/cms/homepagePersonalization/cpd/CPDTypes";

interface TargetFilterProps {
  targets: FilterOptionDTO[];
  selectedTarget?: FilterOptionDTO;
  handleClick: (target: FilterOptionDTO, index: number) => void;
  selectedTargetIndex: number;
}

const TargetFilter = ({ targets = [], handleClick, selectedTarget }: TargetFilterProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLLIElement>, value: string) => {
    const selectedOption = targets.find((t) => t.value === value);
    if (selectedOption) {
      const index = targets.findIndex((t) => t.value === value);
      handleClick(selectedOption, index);
    }
  };

  return (
    <SelectChip
      values={targets}
      value={selectedTarget ? selectedTarget.value : ""}
      onChange={handleChange}
      showSelectedIcon
    />
  );
};

export default TargetFilter;
